import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';
import { DialogContent } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question: {
		padding: '30px 30px 20px 30px',
		fontWeight: 600,
		fontSize: 18,
		textAlign: 'left',
	},
	actions: {
		padding: 10,
	},
	warningButton: {
		borderRadius: 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});

class ConfirmInvalidatePricingRequest extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			invalidReason: 'Request is no longer relevant ',
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName]: event.target.value });
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleInvalidate = () => {
		const {
			//onClose,
			showErrors,
			pricingRequestId,
			invalidatePricingRequest,
		} = this.props;
		if (!pricingRequestId) {
			return showErrors(['Missing pricing request']);
		}

		const { invalidReason } = this.state;
		if (!invalidReason) {
			showErrors(['A reason for marking invoice invalid is required.']);
			return;
		}

		invalidatePricingRequest({
			params: {
				invalidReason,
				pricingRequestId,
			},
			callback: (err) => {
				if (!err) {
					this.props.onClose();
				}
			},
		});
	};

	render() {
		const { classes, open } = this.props;
		return (
			<Dialog
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>Invalidate Pricing Request</DialogTitle>
				<div className={classes.question}>
					Are you sure you want to mark this pricing request invalid?
				</div>

				<DialogContent>
					<TextField
						value={this.state.invalidReason}
						onChange={(event) => this.onChange(event, 'invalidReason')}
						label="Reason for marking invoice invalid"
						fullWidth
					/>
				</DialogContent>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							variant="contained"
							onClick={this.handleInvalidate}
							className={classes.warningButton}
						>
							Yes, mark pricing request as invalid
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmInvalidatePricingRequest.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	//- Could be either
	pricingRequestId: PropTypes.number,
	history: PropTypes.object.isRequired,

	invalidatePricingRequest: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ConfirmInvalidatePricingRequest);
